module.exports = __webpack_public_path__ + "static/media/zero-init.f375b986.jpeg";